var arrPrototype = Array.prototype;
var splice = arrPrototype.splice;
var indexOf = arrPrototype.indexOf;
var pull = function (arr) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    for (var i = 0; i < values.length; i++) {
        var value = values[i];
        var fromIndex = -1;
        while ((fromIndex = indexOf.call(arr, value)) > -1) {
            splice.call(arr, fromIndex, 1);
        }
    }
    return arr;
};
export default pull;
//# sourceMappingURL=pull.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/@antv/util/esm/lodash/pull.js
// module id = null
// module chunks = 